
<div class="row allview">
	<div class="col-sm-3 menu">
		<div class="accordion accordion-flush baseAccordion" id="accordionFlushExample">
			<div></div>
			<div class="accordion-item accordionItemAdjust">
				<div class="accordion-header">
					<button class="accordion-button collapsed accordionButton" type="button"
						(click)="goto('/user-profile')">
						<i class="fa fa-user fa-2x"></i>
						<span><a>{{ modelService.getString('menu_user_data') }}</a></span>
					</button>
				</div>
			</div>

			<div *ngIf="modelService.getUser().isAdmins" class="accordion-item accordionItemAdjust">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed accordionButton" type="button"
						(click)="goto('/registerinter')">
						<i class="fa fa-user-plus fa-2x"></i>
						<span>{{modelService.getString('menu_new_user')}}</span>
					</button>
				</h2>
			</div>

			<div *ngIf="modelService.getUser().isAdmins" class="accordion-item accordionItemAdjust">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed accordionButton" type="button"
						(click)="goto('/user-list')">
						<i class="fa fa-users fa-2x"></i>
						<span><a>{{ modelService.getString('menu_user_list') }}</a></span>
					</button>
				</h2>
			</div>

			<div class="accordion-item accordionItemAdjust">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed accordionButton" type="button"
						(click)="goto('/estimation-list')">
						<i class="fa fa-briefcase fa-2x"></i>
						<span><a>{{ modelService.getString('menu_my_estimations') }}</a></span>
					</button>
				</h2>
			</div>

			<div class="accordion-item accordionItemAdjust">
				<h2 class="accordion-header" id="AClastProyects">
					<button class="accordion-button collapsed accordionButton" type="button" data-bs-toggle="collapse"
						data-bs-target="#COlastProyects" aria-expanded="false" aria-controls="COlastProyects">
						<i class="fa fa-history fa-2x"></i>
						<span>{{modelService.getString('menu_last_projects')}}</span>
					</button>
				</h2>
				<div id="COlastProyects" class="accordion-collapse collapse accordionSubItems"
					aria-labelledby="AClastProyects" data-bs-parent="#accordionFlushExample">
					<div *ngFor="let last of listLastProjects; let index = index;"
						class="accordion-body text-truncate itemLastProjects"
						(click)="openProject(last.id, last.title)">
						<i *ngIf="last.editor === 'canvas2d'" class="fa fa-map-o"></i>
						<i *ngIf="last.editor === 'gmaps'" class="fa fa-globe"></i>
						&nbsp;{{last.title}}
					</div>
				</div>
			</div>

			<div class="accordion-item accordionItemAdjust">
				<h2 class="accordion-header" id="AClenguages">
					<button class="accordion-button collapsed accordionButton" type="button" data-bs-toggle="collapse"
						data-bs-target="#COlenguages" aria-expanded="false" aria-controls="COlenguages">
						<i class="fa fa-language fa-2x"></i>
						<span>{{modelService.getString('menu_language')}}</span>
					</button>
				</h2>
				<!-- ACCORDION LANGUAGE -->
				<div id="COlenguages" class="accordion-collapse collapse accordionSubItems"
					aria-labelledby="AClenguages" data-bs-parent="#accordionFlushExample">
					<div class="accordion-body">
						<ul class="lang_selector" style="text-align: left;">
							<li (click)="updateLanguage('es')">
								<img src="/assets/img/flags/es.png" alt="Castellano" />
								<span>&nbsp;Castellano</span>
							</li>

							<li (click)="updateLanguage('ca')">
								<img src="/assets/img/flags/ca.png" alt="Català" />
								<span>&nbsp;Català</span>
							</li>

							<li (click)="updateLanguage('fr')">
								<img src="/assets/img/flags/fr.png" alt="France" />
								<span>&nbsp;Français</span>
							</li>

							<li (click)="updateLanguage('en')">
								<img src="/assets/img/flags/en.png" alt="English" />
								<span>&nbsp;English</span>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="accordion-item accordionItemAdjust">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed accordionButton" type="button" (click)="logout();">
						<i class="fa fa-window-close fa-2x"></i>
						<span><a>{{ modelService.getString('menu_logout') }}</a></span>
					</button>
				</h2>
			</div>

			<div class="accordion-item accordionItemAdjust">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed accordionButton" type="button">
						<i class="fa fa-question fa-2x"></i>
						<span><a href="{{modelService.getString('menu_support_url')}}"
								target="_blank">{{modelService.getString('menu_support')}}</a></span>
					</button>
				</h2>
			</div>
			<div></div>
		</div>
	</div>

	<div class="col-sm-9 fondo">
		<!-- Logotipo y Usuario -->
		<div class="row justify-content-center interRowTitle">
			<div class="col-md-3">
				<img class="logoRivisaHold"
					src="/assets/img/rivisa-logo-{{ modelService.getLanguage().currentLanguage }}.png"/>
			</div>
			<div class="col-md-3 offset-1">
				<div class="spanUser">{{ modelService.getString('header_welcome')}},&nbsp;{{ modelService.getUser().getData().nombre }}</div>
			</div>
		</div>
		<!-- Input nombre del proyecto -->
		<div class="row justify-content-center interRowInput">
			<div class="col-md-7">
				<div *ngIf="errorProyecto" style="color:red; font-style: italic; height: 24px;">
					{{modelService.getString('hold_error_nameProject')}}</div>
				<div *ngIf="!errorProyecto" style="height: 24px;"></div>
				<div class="input-group mb-3">
					<span class="input-group-text inputTitleProject" id="projectName">{{modelService.getString('project_name')}}</span>
					<input type="text" class="form-control inputTitleProject" aria-label="Username" [(ngModel)]="nombreProyecto"
						aria-describedby="projectName" id="nombreProyectoFocus">
				</div>
			</div>
		</div>
		<!-- Botones de los dos editores -->
		<div class="row justify-content-center">
			<div class="col-md-3">
				<img src="../../assets/img/new/esquema.jpg" class="buttonEditors" (click)="newProject(true)" />
				<div class="textButtonEditors">{{modelService.getString('hold_scheme')}}</div>
			</div>
			<div class="col-md-3 offset-1">
				<img src="../../assets/img/new/satelite.jpg" class="buttonEditors" (click)="newProject(false)" />
				<div class="textButtonEditors">{{modelService.getString('hold_satelite')}}</div>
			</div>
		</div>
	</div>

</div>

<app-alert #alertWindow ></app-alert>

